export default __webpack_public_path__ + "static/media/cp_geo_gs.62046d1a.svg";